/** 节点视觉主题（无光晕） */
export const NODE_THEME_IDS = [
  'zen',
  'blueprint',
  'slate',
  'terminal',
  'brutal',
  'film',
  'notebook',
  'swiss',
  'outline',
  'compact',
  'panel',
  'editorial',
] as const

export type NodeThemeId = (typeof NODE_THEME_IDS)[number]

export const DEFAULT_NODE_THEME: NodeThemeId = 'slate'

/** 连线动效（无光晕） */
export const EDGE_ANIM_IDS = [
  'solid',
  'flow-stream',
  'flow-comet',
  'flow-neon',
  'dash-flow',
  'dash-slow',
  'dash-fast',
  'dash-reverse',
  'dot-march',
  'dot-sparse',
  'morse',
  'snake',
  'double-track',
  'braid',
  'rail',
  'packet',
  'beads',
  'wave',
  'tick',
  'step',
  'gradient-shift',
  'cross-dash',
  'pipe',
  'heartbeat',
  'lane',
] as const

export type EdgeAnimId = (typeof EDGE_ANIM_IDS)[number]

export const DEFAULT_EDGE_ANIM: EdgeAnimId = 'flow-stream'

export interface ThemeOptionMeta {
  id: string
  nameKey: string
  descKey: string
  /** 预览条 / 卡片 accent */
  accent: string
}

export const NODE_THEMES: ThemeOptionMeta[] = [
  { id: 'zen', nameKey: 'canvas.theme.node.zen.name', descKey: 'canvas.theme.node.zen.desc', accent: '#94a3b8' },
  { id: 'blueprint', nameKey: 'canvas.theme.node.blueprint.name', descKey: 'canvas.theme.node.blueprint.desc', accent: '#38bdf8' },
  { id: 'slate', nameKey: 'canvas.theme.node.slate.name', descKey: 'canvas.theme.node.slate.desc', accent: '#64748b' },
  { id: 'terminal', nameKey: 'canvas.theme.node.terminal.name', descKey: 'canvas.theme.node.terminal.desc', accent: '#4ade80' },
  { id: 'brutal', nameKey: 'canvas.theme.node.brutal.name', descKey: 'canvas.theme.node.brutal.desc', accent: '#facc15' },
  { id: 'film', nameKey: 'canvas.theme.node.film.name', descKey: 'canvas.theme.node.film.desc', accent: '#f97316' },
  { id: 'notebook', nameKey: 'canvas.theme.node.notebook.name', descKey: 'canvas.theme.node.notebook.desc', accent: '#fb7185' },
  { id: 'swiss', nameKey: 'canvas.theme.node.swiss.name', descKey: 'canvas.theme.node.swiss.desc', accent: '#ef4444' },
  { id: 'outline', nameKey: 'canvas.theme.node.outline.name', descKey: 'canvas.theme.node.outline.desc', accent: '#818cf8' },
  { id: 'compact', nameKey: 'canvas.theme.node.compact.name', descKey: 'canvas.theme.node.compact.desc', accent: '#06b6d4' },
  { id: 'panel', nameKey: 'canvas.theme.node.panel.name', descKey: 'canvas.theme.node.panel.desc', accent: '#a78bfa' },
  { id: 'editorial', nameKey: 'canvas.theme.node.editorial.name', descKey: 'canvas.theme.node.editorial.desc', accent: '#d4d4d8' },
]

export const EDGE_ANIMATIONS: ThemeOptionMeta[] = [
  { id: 'solid', nameKey: 'canvas.theme.edge.solid.name', descKey: 'canvas.theme.edge.solid.desc', accent: '#64748b' },
  { id: 'flow-stream', nameKey: 'canvas.theme.edge.flowStream.name', descKey: 'canvas.theme.edge.flowStream.desc', accent: '#818cf8' },
  { id: 'flow-comet', nameKey: 'canvas.theme.edge.flowComet.name', descKey: 'canvas.theme.edge.flowComet.desc', accent: '#22d3ee' },
  { id: 'flow-neon', nameKey: 'canvas.theme.edge.flowNeon.name', descKey: 'canvas.theme.edge.flowNeon.desc', accent: '#a855f7' },
  { id: 'dash-flow', nameKey: 'canvas.theme.edge.dashFlow.name', descKey: 'canvas.theme.edge.dashFlow.desc', accent: '#6366f1' },
  { id: 'dash-slow', nameKey: 'canvas.theme.edge.dashSlow.name', descKey: 'canvas.theme.edge.dashSlow.desc', accent: '#6366f1' },
  { id: 'dash-fast', nameKey: 'canvas.theme.edge.dashFast.name', descKey: 'canvas.theme.edge.dashFast.desc', accent: '#6366f1' },
  { id: 'dash-reverse', nameKey: 'canvas.theme.edge.dashReverse.name', descKey: 'canvas.theme.edge.dashReverse.desc', accent: '#6366f1' },
  { id: 'dot-march', nameKey: 'canvas.theme.edge.dotMarch.name', descKey: 'canvas.theme.edge.dotMarch.desc', accent: '#22d3ee' },
  { id: 'dot-sparse', nameKey: 'canvas.theme.edge.dotSparse.name', descKey: 'canvas.theme.edge.dotSparse.desc', accent: '#22d3ee' },
  { id: 'morse', nameKey: 'canvas.theme.edge.morse.name', descKey: 'canvas.theme.edge.morse.desc', accent: '#a855f7' },
  { id: 'snake', nameKey: 'canvas.theme.edge.snake.name', descKey: 'canvas.theme.edge.snake.desc', accent: '#6366f1' },
  { id: 'double-track', nameKey: 'canvas.theme.edge.doubleTrack.name', descKey: 'canvas.theme.edge.doubleTrack.desc', accent: '#94a3b8' },
  { id: 'braid', nameKey: 'canvas.theme.edge.braid.name', descKey: 'canvas.theme.edge.braid.desc', accent: '#6366f1' },
  { id: 'rail', nameKey: 'canvas.theme.edge.rail.name', descKey: 'canvas.theme.edge.rail.desc', accent: '#475569' },
  { id: 'packet', nameKey: 'canvas.theme.edge.packet.name', descKey: 'canvas.theme.edge.packet.desc', accent: '#f97316' },
  { id: 'beads', nameKey: 'canvas.theme.edge.beads.name', descKey: 'canvas.theme.edge.beads.desc', accent: '#ec4899' },
  { id: 'wave', nameKey: 'canvas.theme.edge.wave.name', descKey: 'canvas.theme.edge.wave.desc', accent: '#06b6d4' },
  { id: 'tick', nameKey: 'canvas.theme.edge.tick.name', descKey: 'canvas.theme.edge.tick.desc', accent: '#64748b' },
  { id: 'step', nameKey: 'canvas.theme.edge.step.name', descKey: 'canvas.theme.edge.step.desc', accent: '#6366f1' },
  { id: 'gradient-shift', nameKey: 'canvas.theme.edge.gradientShift.name', descKey: 'canvas.theme.edge.gradientShift.desc', accent: '#818cf8' },
  { id: 'cross-dash', nameKey: 'canvas.theme.edge.crossDash.name', descKey: 'canvas.theme.edge.crossDash.desc', accent: '#94a3b8' },
  { id: 'pipe', nameKey: 'canvas.theme.edge.pipe.name', descKey: 'canvas.theme.edge.pipe.desc', accent: '#64748b' },
  { id: 'heartbeat', nameKey: 'canvas.theme.edge.heartbeat.name', descKey: 'canvas.theme.edge.heartbeat.desc', accent: '#ef4444' },
  { id: 'lane', nameKey: 'canvas.theme.edge.lane.name', descKey: 'canvas.theme.edge.lane.desc', accent: '#475569' },
]

export const LS_NODE_THEME = 'silkreels.canvas.nodeTheme'
export const LS_EDGE_ANIM = 'silkreels.canvas.edgeAnim'

export function isNodeThemeId(v: string): v is NodeThemeId {
  return (NODE_THEME_IDS as readonly string[]).includes(v)
}

export function isEdgeAnimId(v: string): v is EdgeAnimId {
  return (EDGE_ANIM_IDS as readonly string[]).includes(v)
}

/** 需要额外 SVG 层的动效 */
export const EDGE_MULTI_LAYER: Record<EdgeAnimId, number> = {
  solid: 1,
  'flow-stream': 1,
  'flow-comet': 1,
  'flow-neon': 2,
  'dash-flow': 1,
  'dash-slow': 1,
  'dash-fast': 1,
  'dash-reverse': 1,
  'dot-march': 1,
  'dot-sparse': 1,
  morse: 1,
  snake: 1,
  'double-track': 2,
  braid: 2,
  rail: 2,
  packet: 1,
  beads: 1,
  wave: 1,
  tick: 1,
  step: 1,
  'gradient-shift': 1,
  'cross-dash': 1,
  pipe: 1,
  heartbeat: 1,
  lane: 2,
}
